import React, { useState, useEffect } from "react";
import "./styles.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const COUNTDOWN_TARGET = new Date("2026-04-25T23:59:59");

const getTimeLeft = () => {
	const totalTimeLeft = COUNTDOWN_TARGET - new Date();
	const d\u00edas = Math.floor(totalTimeLeft / (1000 * 60 * 60 * 24));
	const horas = Math.floor((totalTimeLeft / (1000 * 60 * 60)) % 24);
	const min = Math.floor((totalTimeLeft / (1000 * 60)) % 60);
	const seg = Math.floor((totalTimeLeft / 1000) % 60);
	return { d\u00edas, horas, min, seg };
};

const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft());

	useEffect(() => {
		const timer = setInterval(() => {
			setTimeLeft(getTimeLeft());
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<Container className='countdown'>
            <Row>
                <Col className="text-reloj"> 
                    <h2>Faltan:</h2>
                </Col>

                <Col className='content'>
                    {Object.entries(timeLeft).map((el) => {
                        const label = el[0];
                        const value = el[1];
                        return (
                            <div className='box' key={label}>
                                <div className='value'>
                                    <span>{value}</span>
                                </div>
                                <span className='label'> {label} </span>
                            </div>
                        );
                    })}
                </Col>
            </Row>
		</Container>
	);
};

export default Countdown;